module.exports = __webpack_public_path__ + "img/avatar_random_4.7613cf5a.png";